import script from "./EditExamView.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditExamView.vue?vue&type=script&setup=true&lang=ts"

import "./EditExamView.vue?vue&type=style&index=0&id=5d5962e2&scoped=true&lang=css"
import "./EditExamView.vue?vue&type=style&index=1&id=5d5962e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d5962e2"]])

export default __exports__